import { FormattedMessage } from 'react-intl';

import NotFoundIcon from '@/assets/icons/not-found.svg';

import { Typography } from './typography';

export function NotFound() {
  return (
    <div className="mx-auto flex min-h-screen w-[300px] flex-col items-center justify-center">
      <img src={NotFoundIcon} alt="Not found" />
      <Typography variant="body2">
        <FormattedMessage
          defaultMessage="Page not found"
          description="404 title in Source when route does not match"
        />
      </Typography>
      <Typography variant="subtitle1" className="text-center">
        <FormattedMessage
          defaultMessage="Looks like the page you're looking for doesn't exist or has been moved."
          description="404 body: friendly message below the not-found title"
        />
      </Typography>
    </div>
  );
}
